import React, { Component } from "react";
import Select, { components } from "react-select";
//import "./example.css";

class CustomMultiSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      values: props.values || props.defaultValue,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.values) {
      return;
    }
    if (prevProps.values.length !== this.props.values.length) {
      this.setState({ values: this.props.values });
    }
  }

  handleChange(values, actionMeta) {
    let option;

    if (actionMeta.action === "clear") {
      option = "DESELECT_ALL";
    } else {
      option = actionMeta.option;
    }

    let newValues = values;

    if (option.value === "SELECT_ALL") {
      newValues = [...this.props.options];
    } else if (option.value === "DESELECT_ALL") {
      newValues = [];
    }

    this.setState({ values: newValues });
    this.props.onChange(newValues);
  }

  render() {
    const { values } = this.state;

    return (
      <div>
        <Select
          hideSelectedOptions={values.length < 1}
          isMulti
          options={[
            { value: "SELECT_ALL", label: "Select All" },
            { value: "DESELECT_ALL", label: "Deselect All" },
            ...this.props.options,
          ]}
          onChange={this.handleChange}
          value={values}
          components={{ ValueContainer }}
          itemName={this.props.itemName}
          closeMenuOnSelect={false}
        />
      </div>
    );
  }
}

export default CustomMultiSelect;

const ValueContainer = ({ children, getValue, ...props }) => {
  let maxToShow = 1;
  var length = getValue().length;
  let displayChips = React.Children.toArray(children).slice(0, maxToShow);
  let shouldBadgeShow = length > maxToShow;
  let displayLength = length;

  if (length > maxToShow || length === 0) {
    displayChips = [];
  }

  const newChildren = [...children];

  if (shouldBadgeShow) {
    newChildren[0] = `${displayLength} item${length !== 1 ? "s" : ""} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {newChildren}
    </components.ValueContainer>
  );
};
